import $axios from "@/plugins/axios"
export default class PostalCodeApi {
  async getPostalCode({ code }) {
    return await $axios({
      method: "GET",
      url: `/postal-code/${code}`,
    })
  }
}
